module.exports = __webpack_public_path__ + "media/Video 47.e5c73d22.mp4";